export const LOGIN_MAP: any = {
    ECOFLOW_WEB_COMMUNITY: 'ECOFLOW_WEB_COMMUNITY',
};

export const SUBSCRIBE_MAP: any = {
    ECOFLOW_WEB_COMMUNITY: 'ECOFLOW_COMMUNITY',
};

export const FORUM_APPID_MAP: any = {
    us: '201',
    uk: '202',
    au: '203',
    ca: '204',
    jp: '205',
    fr: '206',
    de: '207',
    kr: '208',
    eu: '209',
    es: '211',
    it: '213',
    za: '215',
    sa: '216',
    br: '218',
    pl: '221',
    se: '222',
    mx: '224',
    ph: '225',
    nl: '227',
};

export type LangCode = 'en' | 'fr' | 'es' | 'de' | 'it' | 'nl' | 'ja' | 'pt-BR' | 'es-MX';

export const LangCodeMap: Record<LangCode, { bcp47: string; label: string; labelCH: string }> = {
    en: { bcp47: 'en-US', label: 'English', labelCH: '英语' },
    fr: { bcp47: 'fr-FR', label: 'Français', labelCH: '法语' },
    es: { bcp47: 'es-ES', label: 'Español', labelCH: '西班牙语' },
    de: { bcp47: 'de-DE', label: 'Deutsch', labelCH: '德语' },
    it: { bcp47: 'it-IT', label: 'Italiano', labelCH: '意大利语' },
    nl: { bcp47: 'nl-NL', label: 'Nederlands', labelCH: '荷兰语' },
    ja: { bcp47: 'ja-JP', label: '日本語', labelCH: '日语' },
    'pt-BR': { bcp47: 'pt-BR', label: 'Português (Brasil)', labelCH: '葡萄牙语(巴西)' },
    'es-MX': { bcp47: 'es-MX', label: 'Español (México)', labelCH: '西班牙语(墨西哥)' },
};

export const appIdMapLang: Record<string, LangCode> = {
    '201': 'en',
    '202': 'en',
    '203': 'en',
    '204': 'en',
    '205': 'ja',
    '206': 'fr',
    '207': 'de',
    '209': 'en',
    '211': 'es',
    '213': 'it',
    '215': 'en',
    '218': 'pt-BR',
    '224': 'es-MX',
    '225': 'en',
    '227': 'nl',
};

export const FORUM_SITE_MAP_LABEL: Record<string, string> = {
    us: 'United States',
    ca: 'Canada',
    mx: 'México',
    ph: 'Pilipinas',
    au: 'Australia',
    eu: 'Europe',
    uk: 'United Kingdom',
    es: 'España',
    it: 'Italia',
    de: 'Deutschland',
    nl: 'Nederland',
    fr: 'France',
    jp: '日本',
    za: 'South Africa',
    br: 'Brasil',
};

export const COMMUNITY_SITES = ['us', 'ca', 'eu', 'uk', 'es', 'it', 'de', 'nl', 'fr', 'jp', 'mx', 'ph', 'za', 'au', 'br'];

export const CENTER_TO_LOCALES: Record<string, string[]> = {
    EU: ['eu', 'uk', 'es', 'it', 'de', 'nl', 'fr', 'jp', 'za'],
    US: ['us', 'ca', 'mx', 'ph', 'au', 'br'],
};

export const APPID_TO_LOCALE: Record<string, string> = Object.entries(FORUM_APPID_MAP).reduce(
    (acc, [locale, appId]) => ({ ...acc, [String(appId)]: locale }),
    {} as Record<string, string>,
);
